export const currency = 'INR';
export const currentYear = new Date().getFullYear();
export const developedByLink = 'https://accruewise.in/';
export const developedBy = 'Accruewise';
export const contactUs = '';
export const buyLink = '';
export const basePath = '';
export const DEFAULT_PAGE_TITLE = 'Accruewise | Admin Panel';

// Replace the URL's value in env with your backend's URL or if you're using nextjs's API, add the server's origin URL
export const API_BASE_PATH = '';
export const colorVariants = ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark', 'purple', 'pink', 'orange', 'light', 'link'];